import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import { updateBadgesConfig } from "../apiConfigs";

export const updateBadgesApi = createAsyncThunk(
    "auth/crowns-and-badges/updateBadges",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(updateBadgesConfig, payload);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
const intialState = { result: null, loading: false, error: null, message: "", success: false };
const updateBadgesSlice = createSlice({
    name: "auth/crowns-and-badges/updateBadges",
    initialState: intialState,
    reducers: {
        resetUpdateBadges: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(updateBadgesApi.pending, (state) => {
            state.loading = true;
            state.success = false;
        });
        builder.addCase(updateBadgesApi.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action?.payload?.result;
            state.message = action?.payload?.message;
            state.success = true;
        });
        builder.addCase(updateBadgesApi.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error;
            state.message = action?.payload?.message;
            state.success = false;
        });
    },
});
export const { resetUpdateBadges } = updateBadgesSlice.actions;
export const updateBadgesReducer = updateBadgesSlice.reducer;
